<script setup lang="ts">
import {
  defineProps,
  defineEmits,
  withDefaults,
  useSlots,
  computed,
} from "vue";
import XIcon from "@/views/Auth/components/XIcon.vue";

const slots = useSlots();

const props = withDefaults(
  defineProps<{
    show: boolean;
    leftImageAsset?: string;
    maxHeight?: string;
    maxWidth?: string;
    showCloseIcon?: boolean;
  }>(),
  {
    showCloseIcon: true,
  }
);

const emits = defineEmits(["close"]);

const hasLeftSide = computed(() => {
  return !!slots["left-side"] || !!props.leftImageAsset;
});
</script>

<template>
  <Teleport to="body">
    <!-- Overlay Transition -->
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="show"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200] p-4"
        @click.self="emits('close')"
      >
        <transition
          enter-active-class="transition duration-300 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-200 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <div
            class="w-[800px] flex relative"
            :style="{
              maxHeight: maxHeight || undefined,
              maxWidth: maxWidth || undefined,
            }"
          >
            <!-- CLOSE ICON -->
            <div
              v-if="showCloseIcon"
              class="absolute top-6 right-6 cursor-pointer"
              @click="emits('close')"
            >
              <XIcon class="text-black" />
            </div>
            <!-- IMAGE LEFT PART -->
            <div
              v-if="hasLeftSide"
              class="hidden sm:block w-1/2 relative rounded-l-[20px] overflow-hidden"
            >
              <slot name="left-side">
                <img
                  :src="leftImageAsset"
                  alt="left image"
                  class="w-full h-full object-cover object-center select-none pointer-events-none"
                />
              </slot>
            </div>
            <!-- INPUTS RIGHT PART -->
            <div
              class="flex flex-col border-y border-r border-ternary bg-white px-4 py-6 sm:pr-6 sm:py-6 w-full"
              :class="{
                'rounded-[20px] sm:pl-6': !hasLeftSide,
                'sm:w-1/2 max-sm:rounded-l-[20px] rounded-r-[20px] sm:pl-10':
                  hasLeftSide,
              }"
            >
              <slot />
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </Teleport>
</template>
